import { tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { DBDef_FHIRResourceParam } from '../fhir-resource-param/index.js';
const Validator_ModifiableProps = {
    value: tsValidateString(),
    label: tsValidateString(undefined, false),
    paramId: tsValidateUniqueId,
};
const Validator_GeneratedProps = {};
export const DBDef_FHIRResourceParamValue = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'fhir-resource-param-value',
    entityName: 'FHIR Resource Param Value',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'fhir-resource-param-value'
    },
    backend: {
        name: 'fhir-resource-param-value'
    },
    dependencies: {
        paramId: {
            dbKey: DBDef_FHIRResourceParam.dbKey,
            fieldType: 'string',
        }
    }
};
//# sourceMappingURL=db-def.js.map